import React from "react";
import { MdOutlineSettingsVoice } from "react-icons/md";
import { getFilmStyle } from "..";
import { ParticipantView } from "../../base/participants";
import { connect } from "../../base/redux";

function VadFilm({
    dominantSpeaker, width, height
}) {
    return (
        <>
            <div className="item noPin" style={{width: `${width}px`, height: `${height}px`}}>
                { dominantSpeaker ? 
                    <ParticipantView 
                        participantId={dominantSpeaker}
                    />
                    :
                    <>
                        <MdOutlineSettingsVoice size={20} />
                        no voice activity
                    </>
                }            
            </div>
        </>
    )
}

function _mapStateToProps(state) {
    // get audio track all
    const { dominantSpeaker } = state['features/base/participants'];    
    const { width, height } = getFilmStyle(state, 1, true);
    
    return {
        dominantSpeaker,
        width, height
    }
}

export default connect(_mapStateToProps)(VadFilm);